import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiCheckboxTypeComponent } from './multi-checkbox-type.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

@NgModule({
  declarations: [MultiCheckboxTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'multi-checkbox',
          component: MultiCheckboxTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
  ],
})
export class MultiCheckboxTypeModule {}
